import { useState } from "react";
import StatementToolTip from "../../../../component/instance/table/StatementToolTip";
import { rowItemClass, rowDepthStyle } from "./rowStyle";

function BlockingSqlCell(props: { cell: any, instanceId: string | number, instanceType: string }) {
    const { cell, instanceId, instanceType } = props;
    const [tooltipPosition, setTooltipPosition] = useState<number | null>(null);

    return (
        <div
            className={rowItemClass(cell.row, 'tooltip-scroll ellipsis left-side')}
            style={rowDepthStyle(cell.row)}
            onMouseEnter={() => setTooltipPosition(-150)}
            onMouseLeave={() => setTooltipPosition(null)}
        >
            {cell.render('Cell')}
            {tooltipPosition !== null && cell.row.values.sqltext &&
                <StatementToolTip instanceType={instanceType}
                                  position={tooltipPosition}
                                  id={`${cell.row.original.sqlhash}-${cell.row.values.session}-${cell.row.id}`}
                                  link={`/instances/${instanceId}/activity/statement/${cell.row.values.sqlhash}/text`}
                                  cell={cell}/>
            }
        </div>
    );
}

export default BlockingSqlCell;
